import { StateManager } from "./statemanager";
import { State } from "./state";
import { GDM } from "../helpers/datamanager";
import { enumToName } from "../util/generic";
import { LoginClient } from "../net/loginclient";
import { WorldClient } from "../net/worldclient";
import { GameClient } from "../net/gameclient";
import { NETLOGINREPLY } from "../net/networkconstants";

export class GameTestState extends State {
    constructor() {
        super();
    }

    async prepare(): Promise<void> {
        // No preparation needed for game test state
    }

    enter() {
        // Grab user/pass from local storage
        let autologin_username = localStorage.getItem("autologin_user");
        let autologin_pass = localStorage.getItem("autologin_pass");
        let autologin_server = localStorage.getItem("autologin_server");
        let autologin_char = localStorage.getItem("autologin_char");
        let autologin_channel = localStorage.getItem("autologin_channel");
        // Help out by setting some initial but blank entries.
        if (!autologin_username) {
            localStorage.setItem("autologin_user", "test");
            autologin_username = localStorage.getItem("autologin_user");
        }
        if (!autologin_pass) {
            localStorage.setItem("autologin_pass", "test");
            autologin_pass = localStorage.getItem("autologin_pass");
        }
        if (!autologin_server) {
            localStorage.setItem("autologin_server", "1Genetic");
            autologin_server = localStorage.getItem("autologin_server");
        }
        if (!autologin_char) {
            localStorage.setItem("autologin_char", "Erwt");
            autologin_char = localStorage.getItem("autologin_char");
        }
        if (!autologin_channel) {
            localStorage.setItem("autologin_channel", "Channel1");
            autologin_channel = localStorage.getItem("autologin_channel");
        }
        // Make sure we have some user details
        if (!autologin_username || !autologin_pass) {
            console.warn(
                "You must specify roseuser and rosepass in LocalStorage!"
            );
            return;
        }
        const waitDialog = ui.statusDialog("Connecting...");
        let serverIp = "127.0.0.1";
        let serverName = autologin_server;
        let channelName = autologin_channel;
        // const USE_LIVE_SERVER = false;
        // if (USE_LIVE_SERVER) {
        //     serverIp = "128.241.92.36";
        //     serverName = "1Draconis";
        //     channelName = "Channel 1";
        // }
        // TODO: Move somewhere nice as this is loaded in loginstate
        GDM.get("zone_names", "list_zone", "list_status");
        netLogin = new LoginClient();
        netLogin.connect(serverIp, 29000, function (err: any) {
            waitDialog.setMessage("Connected; Logging In.");
            netLogin.login(
                autologin_username,
                autologin_pass,
                function (data: any) {
                    if ((data.result & 0x7f) !== NETLOGINREPLY.OK) {
                        waitDialog.setMessage(
                            "Failed to Login (" +
                                enumToName(NETLOGINREPLY, data.result) +
                                ")."
                        );
                        netLogin.end();
                        return;
                    }
                    waitDialog.setMessage("Logged In; Finding Server.");
                    let serverIdx = -1;
                    let tServer = undefined;
                    let tChannel = undefined;
                    for (let i = 0; i < data.servers.length; ++i) {
                        tServer = data.servers[i];
                        if (tServer.name === serverName) {
                            serverIdx = tServer.id;
                            break;
                        }
                    }
                    if (serverIdx < 0) {
                        waitDialog.setMessage("Failed to find a server.");
                        netLogin.end();
                        return;
                    }
                    netLogin.channelList(serverIdx, function (data: any) {
                        waitDialog.setMessage(
                            "Found Server; Retrieving endpoint info."
                        );
                        let channelIdx = -1;
                        console.log(data.channels);
                        for (let j = 0; j < data.channels.length; ++j) {
                            tChannel = data.channels[j];
                            if (tChannel.name === channelName) {
                                channelIdx = tChannel.id;
                            }
                        }
                        if (channelIdx < 0) {
                            console.log(data.channels);
                            waitDialog.setMessage("Failed to find a channel.");
                            netLogin.end();
                            return;
                        }
                        netLogin.selectServer(
                            tServer.id,
                            tChannel.id,
                            function (data: any) {
                                waitDialog.setMessage(
                                    "Found Endpoint; Connecting to World Server."
                                );
                                netLogin.end();
                                netWorld = new WorldClient();
                                netWorld.connect(
                                    data.worldIp,
                                    data.worldPort,
                                    data.transferKey1,
                                    autologin_pass,
                                    function () {
                                        waitDialog.setMessage(
                                            "Connected to World Server.  Loading characters."
                                        );
                                        netWorld.characterList(function (
                                            data: any
                                        ) {
                                            waitDialog.setMessage(
                                                "Loaded characters; Selecting one."
                                            );
                                            if (data.characters.length === 0) {
                                                console.log(data.characters);
                                                waitDialog.setMessage(
                                                    "Failed to find a character."
                                                );
                                                netWorld.end();
                                                return;
                                            }
                                            let pickCharName =
                                                data.characters[0].name;
                                            if (autologin_char) {
                                                pickCharName = autologin_char;
                                            }
                                            netWorld.selectCharacter(
                                                pickCharName,
                                                async function (data: any) {
                                                    waitDialog.setMessage(
                                                        "Character Selected. Connecting to Game Server."
                                                    );
                                                    // The pregame state has to be prepared before, if it is not
                                                    //   able to switch synchronously, we risk loosing events
                                                    //   related to the character data.
                                                    await StateManager.prepare(
                                                        "pregame"
                                                    );

                                                    netGame =
                                                        new GameClient();
                                                    netGame.connect(
                                                        data.gameIp,
                                                        data.gamePort,
                                                        data.transferKey1,
                                                        autologin_pass,
                                                        function () {
                                                            waitDialog.close();
                                                            StateManager.switch(
                                                                "pregame"
                                                            );
                                                        }
                                                    );
                                                }
                                            );
                                        });
                                    }
                                );
                            }
                        );
                    });
                }
            );
        });
    }

    leave() {}

    update(delta: any) {}
}

/*
This gamestate fakes the login screen by doing all the networking,
and then jumps you immediately to the GameState state.
 */

/**
 * @constructor
 */

StateManager.register("gametest", GameTestState);
const gsGameTest = StateManager.get("gametest");
